import { Component, OnInit } from "@angular/core";

import { Project } from "../interfaces/project";
import { User } from "../interfaces/user";

import { AuthenticationService } from "../services/authentication.service";
import { ProjectsService } from "../services/projects.service";

@Component({
  selector: "app-store",
  templateUrl: "./store.component.html",
  styleUrls: ["./store.component.css"],
})
export class StoreComponent implements OnInit {
  projects: Project[];
  user: User;
  state = "off";
  pageTitle = "Comprar";
  plansData: object[] = [];
  products: object[] = [];
  option = "grip";

  constructor(
    private projectService: ProjectsService,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    this.authService.getStatus().subscribe((status) => {
      if (status != null) {
        this.projectService
          .getProjectByStatus("activo")
          .valueChanges()
          .subscribe(
            (data: Project[]) => {
              this.products = [];
              data.forEach((project) => {
                this.products.push(project);
              });
            },
            (error) => {
              console.log(error);
            }
          );
      }
    });
  }
}
